import { useMutation } from "@tanstack/react-query";

import { updatePatientInfo } from "../api";

export const useUpdatePatientInfo = () => {
  return useMutation({
    mutationFn: updatePatientInfo,
  });
};
